<template>
    <div class="seller-o2o-index">
        <div class="common-header-wrap">
            <mt-header title="店铺设置" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
      <div class="user-avatar iconfont icon-xiangji" ref="upload_btn" @change="uploadAvatar($event)">
        <img v-if="store_avatar_url" :src="store_avatar_url">
        <input type="hidden" v-model="store_avatar">
        <input type="file" accept="image/jpg,image/png,image/gif,image/bmp,image/jpeg">
      </div>
        <mt-field label="店铺名称" type="text" v-model="settings.store_name" />
        <mt-field label="主营商品" type="text" v-model="settings.store_mainbusiness" />
        <mt-field label="QQ" type="text" v-model="settings.store_qq" />
        <mt-field label="阿里旺旺" type="text" v-model="settings.store_ww" />
        <mt-field label="SEO关键" type="text" v-model="settings.store_keywords" />
        <mt-field label="SEO店铺" type="text" v-model="settings.store_description" />
        <mt-field label="店铺电话" type="text" v-model="settings.store_phone" />
        <mt-button class="ds-button-large" type="primary" v-on:click="submit">保存</mt-button>
    </div>
</template>

<script>
import { uploadStoreImage, getStoreInfo, editStoreInfo } from '../../../api/sellerSetting'
import { Toast } from 'mint-ui'
export default {
  name: 'SellerSettingInfo',
  data () {
    return {
    store_avatar:'',
    store_avatar_url:'',
      settings: {}
    }
  },
  created: function () {
    getStoreInfo().then(res => {
      this.settings = res.result.store_info
      this.store_avatar=this.settings.store_avatar
      this.store_avatar_url=this.settings.store_avatar_url
    }).catch(function (error) {
      Toast(error.message)
    })
  },
  computed: {

  },
  methods: {
    submit () {
      editStoreInfo(this.settings.store_name, this.settings.store_qq, this.settings.store_ww, this.settings.store_phone, this.settings.store_mainbusiness, this.settings.store_keywords, this.settings.store_description, this.store_avatar).then(res => {
        Toast(res.message)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    uploadAvatar (event) {
      if (typeof (event.target.files[0]) === 'undefined') {
        return
      }
      let formdata = new FormData()

      formdata.append('store_avatar', event.target.files[0])
      formdata.append('id', 'store_avatar')

      uploadStoreImage(formdata).then(res => {
        this.store_avatar = res.result.file_name
        this.store_avatar_url = res.result.file_path
      }).catch(function (error) {
        Toast(error.message)
      })
    }

  }
}
</script>
<style lang="scss" scoped>
.user-avatar {
      position: relative;
      width: 5rem;
      height: 5rem;
      margin: 2rem auto;
      text-align: center;
      border:1px solid #e0e0e0;
      img {
        width: 100%;
        height: 100%
      }
      input {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0
      }
    }
    .user-avatar::before {
      position: absolute;
      font-size: 1.5rem;
      line-height: 5rem;
      left: 50%;
      margin-left: -.75rem;
      color: rgba(0, 0, 0, 0.5)
    }
</style>